// Virginia Commonwealth University's undergraduate majors. Read on
// 2026-10-01 from the official 2026-27 Undergraduate Bulletin
// (bulletin.vcu.edu), its A-to-Z program list (/azprograms/), where every
// program sits under the school or college that offers it; that is the
// grouping used here, with the school's own Bulletin page as each group's
// source. Kept: every bachelor's program; the Bulletin lists many majors
// once per concentration ("Music, Bachelor of (B.M.) with a concentration
// in performance/piano"), and each major is one line here with its degrees.
// Left out: minors, certificates, accelerated bachelor's-to-master's
// pathways, the R.N.-B.S. completion program, and the B.A./B.F.A. programs
// offered only at VCUarts Qatar (marked [VCUQ]; the same majors are offered
// in Richmond). The Bulletin calls this the preliminary (launch) version of
// the 2026-2027 edition. "B.F.A" for Photography and Film is printed with
// the period added. Economics is a B.S. in both the School of Business and
// the College of Humanities and Sciences, as the Bulletin lists it.
const majors = {
    "slug": "virginia-commonwealth-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in VCU's official 2026-27 Undergraduate Bulletin, grouped by the school or college that offers it, with the degree it leads to. Concentrations are folded into their major; minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Business",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, School of Business",
                "url": "https://bulletin.vcu.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Financial Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Real Estate",
                    "degree": "B.S."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Humanities and Sciences",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, College of Humanities and Sciences",
                "url": "https://bulletin.vcu.edu/undergraduate/college-humanities-sciences/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Bioinformatics",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Foreign Language",
                    "degree": "B.A."
                },
                {
                    "name": "Forensic Science",
                    "degree": "B.S."
                },
                {
                    "name": "Gender, Sexuality and Women's Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Health, Physical Education and Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies, liberal studies for early and elementary education",
                    "degree": "B.I.S."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mass Communications",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Science",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of the Arts",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, School of the Arts",
                "url": "https://bulletin.vcu.edu/undergraduate/arts/"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "Cinema",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "Craft and Material Studies",
                    "degree": "B.F.A."
                },
                {
                    "name": "Dance and Choreography",
                    "degree": "B.F.A."
                },
                {
                    "name": "Fashion",
                    "degree": "B.A., B.F.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Kinetic Imaging",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M., B.A."
                },
                {
                    "name": "Painting and Printmaking",
                    "degree": "B.F.A."
                },
                {
                    "name": "Photography and Film",
                    "degree": "B.F.A."
                },
                {
                    "name": "Sculpture",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A., B.F.A."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, College of Engineering",
                "url": "https://bulletin.vcu.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical and Life Science Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Robotics and Autonomous Systems Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Health Professions",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, College of Health Professions",
                "url": "https://bulletin.vcu.edu/undergraduate/allied-health-professions/"
            },
            "majors": [
                {
                    "name": "Clinical Radiation Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Health Services",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "L. Douglas Wilder School of Government and Public Affairs",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, L. Douglas Wilder School of Government and Public Affairs",
                "url": "https://bulletin.vcu.edu/undergraduate/government-public-affairs/"
            },
            "majors": [
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Homeland Security and Emergency Preparedness",
                    "degree": "B.A."
                },
                {
                    "name": "Urban and Regional Studies",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Dentistry",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, School of Dentistry",
                "url": "https://bulletin.vcu.edu/undergraduate/dentistry/"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, School of Education",
                "url": "https://bulletin.vcu.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Early Childhood Education and Teaching",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Elementary Education and Teaching",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Health and Physical Education",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Human and Organizational Development",
                    "degree": "B.A."
                },
                {
                    "name": "Secondary Education and Teaching",
                    "degree": "B.S.Ed."
                },
                {
                    "name": "Special Education and Teaching",
                    "degree": "B.S.Ed."
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, School of Nursing",
                "url": "https://bulletin.vcu.edu/undergraduate/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Pharmacy",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, School of Pharmacy",
                "url": "https://bulletin.vcu.edu/undergraduate/pharmacy/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, School of Social Work",
                "url": "https://bulletin.vcu.edu/undergraduate/socialwork/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "University College",
            "source": {
                "label": "VCU 2026-27 Undergraduate Bulletin, University College",
                "url": "https://bulletin.vcu.edu/undergraduate/university-college/"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.I.S."
                }
            ]
        }
    ]
};

export default majors;
